import React from 'react'
import PropTypes from 'prop-types'
import CheckboxList from './CheckboxList'

const CheckboxListField = ({ input, ...props }) =>
  <CheckboxList
    { ...input }
    { ...props } />

export default CheckboxListField

CheckboxListField.propTypes = {
  input: PropTypes.shape()
}
